import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahmednagarcab() {



  const cardData =
  {
    keyword: 'Pune to Ahmednagar Cab',
    heading: 'Sai Trupti Cabs: Pune to Ahmednagar Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Ahmednagar cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Ahmednagar. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Ahmednagar convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Ahmednagar with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort is one of the most formidable and historically significant forts in Maharashtra, built in 1490 by Ahmad Nizam Shah. Known for its circular design and massive walls, the fort played a crucial role during the Deccan Sultanate and later under the Marathas and British. It famously served as a prison for Indian freedom fighters, including Jawaharlal Nehru, who wrote *The Discovery of India* here. Surrounded by a deep moat and sturdy bastions, the fort stands as a powerful symbol of resilience, resistance, and Ahmednagar’s rich past."
  },
  {
    "title": "Meherabad",
    "description": "Meherabad is a serene and spiritually significant site, best known as the final resting place of the spiritual master Meher Baba. Situated on a hill near Ahmednagar, the white marble samadhi draws devotees from around the world seeking peace and inner reflection. The calm surroundings, panoramic views, and deep spiritual energy create a tranquil atmosphere. Especially during Meher Baba’s silence anniversary, the place becomes a center of devotion and meditation. Meherabad is not just a destination — it’s a journey into silence and self-discovery."
  },
  {
    "title": "Chand Bibi Mahal (Salabat Khan’s Tomb)",
    "description": "Chand Bibi Mahal, also known as Salabat Khan’s Tomb, is an architectural gem perched on a hilltop overlooking Ahmednagar city. Built in the 16th century, the structure blends Indo-Islamic design with graceful arches and domes. Though popularly associated with the legendary Chand Bibi, the tomb was constructed for Salabat Khan II, a Deccan noble. The site offers breathtaking views of the surrounding landscape and city below. Its quiet elegance and historical intrigue make it a must-visit for history lovers and photographers."
  },
  {
    "title": "Cavalry Tank Museum",
    "description": "The Cavalry Tank Museum in Ahmednagar is Asia’s first and only museum dedicated to tanks and armored vehicles. Managed by the Indian Army, it showcases an impressive collection of historic tanks used in various wars and military operations. From World War-era machines to modern battle tanks, the museum highlights India’s armored warfare legacy. Well-maintained grounds and informative displays make it both educational and fascinating. It’s a unique attraction that reflects Ahmednagar’s strong military heritage."
  },
  {
    "title": "Bhandardara",
    "description": "Bhandardara is a breathtaking hill station near Ahmednagar, known for its pristine lakes, cascading waterfalls, and lush green landscapes. Nestled in the Sahyadri ranges, it offers refreshing weather and scenic beauty throughout the year. Attractions like Arthur Lake, Wilson Dam, and Randha Falls make it a paradise for nature lovers and photographers. During monsoon, the region transforms into a lush wonderland. Bhandardara is the perfect escape for those seeking tranquility, adventure, and nature’s untouched charm."
  },
  {
    "title": "Ratangad Fort",
    "description": "Ratangad Fort is an ancient hill fort with a history spanning over 400 years, offering panoramic views of the surrounding valleys and Bhandardara region. Known for its iconic ‘Nedhe’ or Eye of the Needle rock formation, the fort is a favorite among trekkers and adventure enthusiasts. Once used by the Marathas to control trade routes, its ruins tell stories of strategic brilliance. Trekking to the summit is both challenging and rewarding. Ratangad combines history, adventure, and breathtaking natural beauty."
  },
  {
    "title": "Rehkuri Blackbuck Sanctuary",
    "description": "Rehkuri Blackbuck Sanctuary is a rare wildlife haven dedicated to the conservation of the endangered Indian blackbuck. Spread across grasslands and scrub forests, it offers visitors a chance to observe blackbucks, foxes, and various bird species in their natural habitat. The sanctuary reflects Ahmednagar’s commitment to wildlife preservation and ecological balance. Early morning and evening visits provide the best sightings. It’s a peaceful retreat for nature lovers and wildlife enthusiasts alike."
  },
  {
    "title": "Siddheshwar Temple",
    "description": "Siddheshwar Temple is a revered spiritual site in Ahmednagar, dedicated to Lord Shiva. Known for its ancient origins and calm surroundings, the temple attracts devotees seeking blessings and inner peace. During Mahashivratri, the temple becomes a vibrant center of devotion and celebration. Its simple yet sacred ambiance reflects the region’s deep-rooted spiritual traditions. Siddheshwar Temple stands as a timeless symbol of faith and devotion in Ahmednagar."
  },
  {
    "title": "Shirdi",
    "description": "Located near Ahmednagar, Shirdi is one of India’s most important pilgrimage destinations, dedicated to the saint Sai Baba. Millions of devotees from across the world visit the Sai Baba Temple seeking blessings, faith, and hope. The town’s spiritual energy, orderly darshan system, and sacred sites like Dwarkamai and Chavadi create a deeply moving experience. Shirdi represents unity, compassion, and selfless devotion. A visit here leaves a lasting spiritual impression on every pilgrim."
  },
  {
    "title": "Mula Dam",
    "description": "Mula Dam is a scenic reservoir near Ahmednagar, offering calm waters and peaceful surroundings ideal for relaxation. Especially beautiful during monsoon and post-monsoon seasons, the dam attracts locals for picnics and sunset views. The gentle breeze, open skies, and reflections on the water create a soothing atmosphere. It’s an excellent spot to unwind away from city life. Mula Dam showcases the serene and natural side of Ahmednagar."
  }
],



"services": [
    {
      "name": "Pune to Ahmednagar Cab",
      "description": "Reliable cab service from Pune to Ahmednagar offering AC and non-AC vehicles, professional drivers, luggage assistance, flexible pickup and drop points, real-time tracking, and transparent pricing. Ideal for families, solo travelers, and business commuters."
    },
    {
      "name": "Ahmednagar to Pune Cab",
      "description": "Comfortable cab service from Ahmednagar to Pune with well-maintained AC/non-AC cars, experienced drivers, luggage support, flexible scheduling, and transparent fares for a smooth travel experience."
    },
    {
      "name": "Ahmednagar to Pune Taxi",
      "description": "Safe and convenient taxi service from Ahmednagar to Pune providing point-to-point travel, professional chauffeurs, AC/non-AC options, luggage assistance, and reliable on-time service."
    },
    {
      "name": "Pune to Ahmednagar One Way Cab",
      "description": "One-way cab service from Pune to Ahmednagar offering direct travel without return charges. Includes AC/non-AC vehicles, professional drivers, flexible pickup locations, and transparent fares."
    },
    {
      "name": "Pune to Ahmednagar Round Trip Taxi",
      "description": "Round-trip taxi service from Pune to Ahmednagar ideal for same-day return or extended stays. Features comfortable vehicles, experienced drivers, luggage support, and cost-effective pricing."
    },
    {
      "name": "Pune to Ahmednagar Innova Cab",
      "description": "Spacious Innova cab service from Pune to Ahmednagar with AC comfort, ample luggage space, and professional drivers. Perfect for families, groups, and corporate travel."
    },
    {
      "name": "Pune to Ahmednagar Innova Crysta Cab",
      "description": "Premium Innova Crysta cab service from Pune to Ahmednagar offering superior comfort, AC luxury seating, professional chauffeurs, and smooth long-distance travel."
    },
    {
      "name": "Pune to Ahmednagar Ertiga Cab",
      "description": "Ertiga cab service from Pune to Ahmednagar suitable for small groups, featuring AC/non-AC options, comfortable seating, luggage assistance, and economical pricing."
    },
    {
      "name": "Pune to Ahmednagar Sedan Cab",
      "description": "Sedan cab service from Pune to Ahmednagar offering smooth rides, professional drivers, AC/non-AC options, and affordable fares for solo travelers and couples."
    },
    {
      "name": "Pune to Ahmednagar SUV Taxi",
      "description": "SUV taxi service from Pune to Ahmednagar providing extra space, AC comfort, powerful performance, and professional drivers for a relaxed long-distance journey."
    },
    {
      "name": "Pune to Ahmednagar AC Cab",
      "description": "AC cab service from Pune to Ahmednagar ensuring cool, comfortable, and safe travel with experienced drivers, luggage support, and transparent pricing."
    },
    {
      "name": "Pune Airport to Ahmednagar Cab",
      "description": "Convenient cab service from Pune Airport to Ahmednagar with timely pickups, flight-tracking support, AC vehicles, professional drivers, and hassle-free travel."
    },
    {
      "name": "Hinjewadi to Ahmednagar Taxi",
      "description": "Taxi service from Hinjewadi to Ahmednagar offering comfortable AC/non-AC rides, experienced drivers, flexible pickup points, and reliable long-distance travel."
    },
    {
      "name": "Wakad to Ahmednagar Cab",
      "description": "Cab service from Wakad to Ahmednagar with well-maintained vehicles, professional chauffeurs, luggage assistance, and transparent fares for smooth travel."
    },
    {
      "name": "Hadapsar to Ahmednagar Taxi",
      "description": "Safe and comfortable taxi service from Hadapsar to Ahmednagar featuring AC/non-AC vehicles, professional drivers, and flexible booking options."
    },
    {
      "name": "Pimpri Chinchwad to Ahmednagar Cab",
      "description": "Reliable cab service from Pimpri Chinchwad to Ahmednagar offering door-to-door pickup, AC/non-AC options, luggage support, and economical pricing."
    },
    {
      "name": "Pune to Ahilyanagar Cab Service",
      "description": "Trusted cab service from Pune to Ahilyanagar (Ahmednagar) with comfortable vehicles, professional drivers, flexible schedules, and transparent fares."
    },
    {
      "name": "Affordable Pune to Ahmednagar Cab",
      "description": "Budget-friendly cab service from Pune to Ahmednagar offering economical rates, AC/non-AC vehicles, professional drivers, and reliable long-distance travel."
    },
    {
      "name": "Best Pune to Ahmednagar Cab Service",
      "description": "Top-rated cab service from Pune to Ahmednagar ensuring comfort, safety, punctuality, professional drivers, and well-maintained vehicles."
    },
    {
      "name": "Pune to Ahmednagar Online Cab Booking",
      "description": "Book Pune to Ahmednagar cabs online instantly with multiple vehicle options, secure payments, real-time tracking, flexible pickup/drop points, and transparent pricing."
    }
  ],
  "tableData": [
    ["Pune to Ahmednagar Cab", "Ahmednagar to Pune Cab"],
    ["Ahmednagar to Pune Taxi", "Pune to Ahmednagar Taxi"],
    ["Pune to Ahmednagar One Way Cab", "Pune to Ahmednagar Round Trip Taxi"],
    ["Pune to Ahmednagar Innova Cab", "Pune to Ahmednagar Innova Crysta Cab"],
    ["Pune to Ahmednagar Ertiga Cab", "Pune to Ahmednagar Sedan Cab"],
    ["Pune to Ahmednagar SUV Taxi", "Pune to Ahmednagar AC Cab"],
    ["Pune Airport to Ahmednagar Cab", "Hinjewadi to Ahmednagar Taxi"],
    ["Wakad to Ahmednagar Cab", "Hadapsar to Ahmednagar Taxi"],
    ["Pimpri Chinchwad to Ahmednagar Cab", "Pune to Ahilyanagar Cab Service"],
    ["Affordable Pune to Ahmednagar Cab", "Best Pune to Ahmednagar Cab Service"],
    ["Pune to Ahmednagar Online Cab Booking", ""]
  ],

"whychoose": [
  {
    "WhyChooseheading": "Pune to Ahmednagar Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Pune to Ahmednagar — perfect for business trips, airport transfers, and family travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Pune to Ahmednagar start from approximately ₹1,500–₹2,300 for sedans, with SUVs and luxury car options available at affordable rates."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage needs, and comfort preferences for the Pune → Ahmednagar route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Ahmednagar route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drop-offs across Ahmednagar — including airports, hotels, stations, and residential areas."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic inter-city ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel assistance, or route planning for your Pune to Ahmednagar cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Ahmednagar cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Ahmednagar cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services from Pune to Ahmednagar for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Pune to Ahmednagar cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Ahmednagar cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Ahmednagar?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Ahmednagar trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Ahmednagar for corporate or personal travel?',
    answer: 'Certainly. Our cab services cater to corporate clients, airport transfers, family trips, and leisure travel between Pune and Ahmednagar.',
  },
  {
    question: 'Is the Pune to Ahmednagar cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Ahmednagar trips for maximum convenience and travel flexibility.',
  },
  {
    question: 'What are the Pune to Ahmednagar cab fares?',
    answer: 'Our cab fares start from approximately ₹1,500 for sedans, ₹2,200–₹3,200 for SUVs and premium vehicles, depending on distance, vehicle type, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Ahmednagar cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Ahmednagar cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Ahmednagar cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Ahmednagar cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'I booked a Pune to Ahmednagar cab with Sai Trupti Cabs. The ride was smooth, and the driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Ahmednagar trip. Comfortable journey and courteous driver.',
    rating: 5,
  },
];












































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ahmednagar Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-ahmednagar-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Ahmednagar cab service with one way taxi, round trip cabs, sedan, SUV, Ertiga and Innova Crysta options. Book affordable outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-ahmednagar-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to Ahmednagar Cab Service | One Way Taxi ₹1999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Ahmednagar cab at best price ₹1999 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, affordable and 24x7 cab service with verified drivers." 
  />

  <meta 
    name="keywords" 
    content="pune to ahmednagar cab, pune to ahmednagar taxi, pune to ahmednagar cab service, pune to ahmednagar one way cab, pune to ahmednagar taxi fare, pune to ahmednagar innova crysta, pune to ahmednagar ertiga cab, pune to ahmednagar sedan cab, cheap pune to ahmednagar cab, best cab service pune to ahmednagar, pune to ahmednagar drop taxi, pune to ahmednagar round trip cab, outstation cab pune to ahmednagar, pune to ahmednagar online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoahmednagarcab;